import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const RateList = React.lazy(() => import('../components/RateList'));
function RateListView(props: Object) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <RateList {...props} />
    </Suspense>
  );
}

export default RateListView;
